import React, { MouseEvent } from "react";

import {
  MessageBoxStyles,
  MessageBoxWidgetDto,
  OfferDto,
  ProgressBarStyles,
  ProgressBarWidgetDto,
  QuantityButtonsStyles,
  QuantityButtonsWidgetDto,
  WidgetType,
} from "@intelligems/ig-types";
import { MessageBoxColorsWrapper } from "@src/components/ColorAndStyle/sections/components/MessageBoxColorsWrapper";
import { QuantityButtonsColorsWrapper } from "@src/components/ColorAndStyle/sections/components/QuantityButtonsColorsWrapper";
import {
  isMessageBox,
  isQuantityButtons,
} from "@src/store/slices/widgets/util";

import { ProgressBarColorsWrapper } from "./components/ProgressBarColorsWrapper";

interface ColorThemeSectionProps {
  widgetType: WidgetType;
  colorTheme: QuantityButtonsStyles | ProgressBarStyles | MessageBoxStyles;
  onColorChange: (field: string, event: MouseEvent<HTMLElement>) => void;
  offer?: OfferDto;
  widget: ProgressBarWidgetDto | QuantityButtonsWidgetDto | MessageBoxWidgetDto;
  quantityButtonVariant?: string;
  disabled?: boolean;
}

export const ColorThemeSection = ({
  widgetType,
  colorTheme,
  onColorChange,
  offer,
  widget,
  quantityButtonVariant,
  disabled,
}: ColorThemeSectionProps) => {
  return (
    <>
      {isQuantityButtons(widget) ? (
        <QuantityButtonsColorsWrapper
          widgetType={widgetType}
          colorTheme={colorTheme as QuantityButtonsStyles}
          onColorChange={onColorChange}
          offer={offer}
          widget={widget}
          quantityButtonVariant={quantityButtonVariant}
        />
      ) : isMessageBox(widget) ? (
        <MessageBoxColorsWrapper
          widgetType={widgetType}
          colorTheme={colorTheme as MessageBoxStyles}
          onColorChange={onColorChange}
          offer={offer}
          widget={widget}
          quantityButtonVariant={quantityButtonVariant}
        />
      ) : (
        <ProgressBarColorsWrapper
          widgetType={widgetType}
          colorTheme={colorTheme as ProgressBarStyles}
          onColorChange={onColorChange}
          offer={offer}
          widget={widget}
          quantityButtonVariant={quantityButtonVariant}
        />
      )}
    </>
  );
};
